export const STORAGE_KEYS = {
  USER: "codearena_user",
  VISITOR_ID: "visitorId",
  APP_CONFIG: "codearena:appConfig",
  BOOTCAMP_AD_DISMISSED: "codearena:bootcampAdDismissed",

  // Theme preferences
  THEME_MODE: "codearena:themeMode",       // 'dark' | 'light' | 'system'
  THEME_COLOR: "codearena:themeColor",     // 'cyberViolet' | 'oceanTeal' | 'royalBlue' | 'roseGold'

  // Prefixes
  CODING_CODE_PREFIX: "codearena:codingCode:",
};

export const getCodingCodeKey = (topicId) => `${STORAGE_KEYS.CODING_CODE_PREFIX}${topicId}`;
